import { v4 as uuidv4 } from "uuid";

import IBaseZone, { IBaseZoneApi, mapApiPointsToPoints, mapPointsToApi } from "./base-zone";
import ZonePointType from "../../../enums/robot/rooms/zone-point-type";

interface RedZone extends IBaseZone {
  name: string | null;
  gateId: string;
  evacuation: boolean;
}

export interface RedZoneApi extends IBaseZoneApi {
  name: string | null;
  gateId: string;
  evacuation: boolean;
}

export const mapRedZoneApiToRedZone = (apiData: RedZoneApi) =>
  ({
    ...apiData,
    points: mapApiPointsToPoints(apiData.points, ZonePointType.RedZoneCorner),
  } as RedZone);

export const mapRedZoneToApi = (redZone: RedZone) =>
  ({
    ...redZone,
    points: mapPointsToApi(redZone.points.map((p) => p.point)),
  } as RedZoneApi);

export const mapPartialRedZoneToApi = (redZone: Partial<RedZone>) =>
  ({
    ...redZone,
    points: redZone.points !== undefined ? mapPointsToApi(redZone.points.map((p) => p.point)) : undefined,
  } as Partial<RedZoneApi>);

export const newRedZone = (name: string, roomId: string, evacuation: boolean | undefined = false, gateId: string = ""): RedZone => {
  return {
    id: uuidv4(),
    room: roomId,
    name,
    gateId,
    evacuation,
    points: [],
  };
};

export const copyRedZone = (zone: RedZone) => {
  return {
    ...zone,
    points: [...zone.points.map((p) => ({ orderIndex: p.orderIndex, point: { ...p.point } }))],
  };
};

export const isRedZone = (payload: unknown) : payload is RedZone => {
  return(
    !!payload &&
    typeof payload === "object" &&
    "id" in payload &&
    "room" in payload &&
    "name" in payload &&
    "gateId" in payload &&
    "evacuation" in payload &&
    "points" in payload
  );
};

export default RedZone; 